import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import setup from "./utils/setup";

setup(Vue);

new Vue({
    router,
    store,
    render: (h) => h(App),
}).$mount("#app");
